import useInput from "hooks/use_input"

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  Typography,
  FormHelperText,
} from "@mui/material"
import useTranslation from "../../../hooks/use_translation"

const Gender = () => {
  const id = "gender"
  const { fields } = useTranslation()

  const validate = (value) => {
    if (value === "") return "This field is required"

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  return (
    <FormControl error={errorMessage?.length > 0}>
      <FormLabel>
        <Typography variant="body2" color="text.middle" sx={{ mt: 2 }}></Typography>
        {fields?.gender_title}
      </FormLabel>

      <RadioGroup
        row
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onTouchEnd={handleBlur}
      >
        <FormControlLabel value="MALE" control={<Radio />} label={fields?.gender_male} />
        <FormControlLabel value="FEMALE" control={<Radio />} label={fields?.gender_female} />
      </RadioGroup>
      <FormHelperText>{errorMessage}</FormHelperText>
    </FormControl>
  )
}

export default Gender
